<template>
  <div class="address-page">
    <div class="title">收货地址</div>
    <div class="address-content">
      <div class="basic-info">
        <div class="name">
          {{ addressInfo.companyName }}
          <span v-if="!hasAuth" class="status">未认证</span>
          <span v-else class="status no">已认证</span>
        </div>
        <div class="address">
          <img class="address-icon" :src="require('@/assets/img/location-icon.png')" alt="" />
          {{ addressInfo.merchantAddr }}
        </div>
        <div class="item" :key="index" v-for="(item, index) in userList">
          <span class="user-name">{{ item.receiverName }}</span>
          <span class="user-mobile">{{ item.receiverMobile }}</span>
          <span @click="editAddress(item)" class="pointer edit">编辑</span>
          <span @click="deleteItem(item)" class="pointer edit">删除</span>
        </div>
        <div @click="addAddress()" class="add-button pointer">新增收货人信息</div>
      </div>
    </div>
    <el-modal-form v-bind.sync="modalsDefault" @submit="modalsSubmit" />
  </div>
</template>

<script>
import * as api from '@/services';
export default {
  created() {
    this.getAuth();
    this.getAddress();
  },
  data() {
    return {
      hasAuth: false,
      addressInfo: {},
      userList: [],
      modalsDefault: {
        title: '新增收货人信息',
        visible: false,
        allLabelWidth: 120,
        dialogOptions: {
          width: '560px',
          alignFooter: 'right'
        },
        loading: false,
        value: {
          name: '',
          mobile: ''
        },
        rules: [
          {
            name: [
              {
                required: true,
                message: '请输入收货人姓名',
                trigger: 'blur'
              }
            ]
          },
          {
            mobile: [
              {
                validator: (rule, value, callback) => {
                  if (!value) {
                    callback(Error('请输入收货人手机号'));
                  } else if (!/^1[3456789]\d{9}$/.test(value)) {
                    callback(Error('请输入正确的手机号'));
                  } else {
                    callback();
                  }
                },
                required: true,
                trigger: 'blur'
              }
            ]
          }
        ],
        unit: [
          {
            type: 'input',
            keystr: 'name',
            label: '收货人姓名',
            elOptions: {
              maxlength: 10
            }
          },
          {
            type: 'input',
            keystr: 'mobile',
            label: '收货人手机号',
            elOptions: {
              maxlength: 11
            }
          }
        ]
      },
      option: 'add',
      editId: ''
    };
  },
  methods: {
    modalsSubmit(data) {
      JSON.stringify(data) === '{}' && this.$message.info('没有填写任何信息');
      const params = {
        receiverName: data.name,
        receiverMobile: data.mobile
      };
      if (this.option === 'edit') {
        params.addrId = this.editId;
      }
      if (this.addressInfo.merchantAddrId) {
        params.merchantAddrId = this.addressInfo.merchantAddrId;
      }
      api.personal
        .modifyReceiveAddr(params)
        .then(res => {
          this.modalsDefault.visible = false;
          this.modalsDefault.loading = false;
          if (this.option === 'edit') {
            this.$message.success('收货人信息编辑成功');
          } else {
            this.$message.success('收货人信息增加成功');
          }
          this.getAddress();
        })
        .catch(err => {
          this.modalsDefault.loading = false;
        });
    },
    async getAuth() {
      const authInfo = await api.personal.getPurchaseAuthDetail();
      this.hasAuth = authInfo.isAuth;
    },
    editAddress(item) {
      this.option = 'edit';
      this.modalsDefault.title = '编辑收货人信息';
      this.modalsDefault.value.name = item.receiverName;
      this.modalsDefault.value.mobile = item.receiverMobile;
      this.modalsDefault.visible = true;
      this.editId = item.addrId;
    },
    addAddress() {
      if (this.userList.length >= 20) {
        this.$message('收货人数量已达上限');
        return;
      }
      this.option = 'add';
      this.modalsDefault.title = '新增收货人信息';
      this.modalsDefault.value.name = '';
      this.modalsDefault.value.mobile = '';
      this.modalsDefault.visible = true;
    },
    deleteItem(item) {
      this.$confirm('确定要删除该收货人吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'custom_confirm_button',
        confirmButtonClass: 'custom_confirm_button',
        title: null,
        alignFooter: 'right',
        type: 'warning'
      }).then(async () => {
        await api.personal.delReceiveAddr({ addrId: item.addrId });
        this.getAddress();
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      });
    },
    async getAddress() {
      const data = await api.personal.getReceiveAddr();
      this.addressInfo = data;
      this.userList = data.receiverList || [];
    }
  }
};
</script>

<style lang="scss" scoped>
.address-page {
  min-height: 539px;
  background-color: #ffffff;
  /deep/ .el-button--primary {
    float: right;
    margin-left: 12px;
  }
  .title {
    padding-left: 24px;
    height: 42px;
    border-bottom: 1px solid #eeeeee;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
  }
  .address-content {
    padding: 16px;
    .basic-info {
      background: #fafafa;
      border: 1px dashed #eeeeee;

      .name {
        padding-left: 16px;
        height: 50px;
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        border-bottom: 1px dashed #eeeeee;
        display: flex;
        align-items: center;
        .status {
          width: 48px;
          height: 18px;
          background: #e7f3ff;
          border-radius: 1px;
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          text-align: center;
          padding: 0 6px;
          margin-left: 8px;

          color: #8c8c8c;
          &.no {
            color: #1e8dff;
          }
        }
      }
      .address {
        padding-left: 16px;
        height: 50px;
        font-size: 16px;
        font-weight: 400;
        color: #727272;
        line-height: 24px;
        border-bottom: 1px dashed #eeeeee;
        display: flex;
        align-items: center;
        .address-icon {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
      .item {
        padding-left: 16px;
        font-size: 16px;
        font-weight: 400;
        color: #727272;
        line-height: 16px;
        margin-top: 16px;
        .user-name {
          min-width: 64px;
          display: inline-block;
        }
        .user-mobile {
          min-width: 104px;
          margin-left: 12px;
        }
        .edit {
          color: #1e8dff;
          margin-left: 12px;
        }
      }
      .add-button {
        width: 116px;
        height: 24px;
        background: #1e8dff;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 24px;
        margin: 22px 0 22px 16px;
      }
    }
  }
}
</style>
